import React, {Component} from 'react'
import YouTube from 'react-youtube'

const Jeyu = {
  Box: {
    padding: '20px 0 50px'
  },
  h2: {
   fontSize: 25,
   color: '#014852',
   fontWeight: '500',
   textAlign: 'center'
  }
}

export default class Youtube extends Component {
  componentDidMount () {
   window.scrollTo(0, 0)
  }
  componentWillUnmount() {
   window.scrollTo(0, 0)
  }
  render() {
    const opts = {
     playerVars: {
     autoplay: 0
    }
   }
    return(
      <div className="container" style={Jeyu.Box}>
       <div className="row">
        <h2 style={Jeyu.h2}>JeyuTex實驗影片</h2>
        <div className="xs-12 sm-6 md-6 lg-6">
         <YouTube
          videoId="wXqTYjK1WJg"
          opts={opts}
          onReady={this._onReady}
          className="youtube"
         />
         <p style={Jeyu.pcenter}>除瞞床包實驗</p>
        </div>
        <div className="xs-12 sm-6 md-6 lg-6">
         <YouTube
          videoId="qYi5lfIec7g"
          opts={opts}
          onReady={this._onReady}
          className="youtube"
         />
        <p style={Jeyu.pcenter}>除蚊蚊帳實驗</p>
       </div>
       <div className="xs-12 sm-6 md-6 lg-6">
        <YouTube
         videoId="x4uZNajRZ6g"
         opts={opts}
         onReady={this._onReady}
         className="youtube"
        />
        <p style={Jeyu.pcenter}>JeyuTex除蟲布料-蛾蚋實驗過程 </p>
      </div>
      <div className="xs-12 sm-6 md-6 lg-6">
       <YouTube
        videoId="RZv6PU3Sr3w"
        opts={opts}
        onReady={this._onReady}
        className="youtube"
       />
       <p style={Jeyu.pcenter}>JeyuTex除蟲布料-蛾蚋實驗放大 </p>
      </div>
      <div className="xs-12 sm-6 md-6 lg-6">
       <YouTube
        videoId="_cY1LPxLGkQ"
        opts={opts}
        onReady={this._onReady}
        className="youtube"
       />
       <p style={Jeyu.pcenter}>JeyuTex除蟲布料-螞蟻實驗過程</p>
      </div>
      <div className="xs-12 sm-6 md-6 lg-6">
       <YouTube
        videoId="CLiyhd9zGD0"
        opts={opts}
        onReady={this._onReady}
        className="youtube"
       />
       <p style={Jeyu.pcenter}>JeyuTex除蟲布料-螞蟻實驗放大</p>
      </div>
     </div>
    </div>
    )
  }
  _onReady(event) {
// access to player in all event handlers via event.target
 event.target.pauseVideo();
}
}



// WEBPACK FOOTER //
// ./src/Component/Youtube.js